import axios from '../../../../utills/axiosConfig';

export const fetchStoneQualities = async (company_code) => {
  const params = {};
  if (company_code) params.company_code = company_code;
  const res = await axios.get('/stone-qualities', { params });
  return res.data;
};

export const addStoneQuality = async (stoneQuality) => {
  try {
    const res = await axios.post('/stone-qualities', stoneQuality);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const updateStoneQuality = async (id, stoneQuality) => {
  console.log('API call - Updating stone quality:', id, stoneQuality);
  const res = await axios.put(`/stone-qualities/${id}`, stoneQuality);
  console.log('API response:', res.data);
  return res.data;
};

export const deleteStoneQuality = async (id) => {
  const res = await axios.delete(`/stone-qualities/${id}`);
  return res.data;
};

export const importStoneQualityCSV = async (formData) => {
  const { data } = await axios.post('/stone-qualities/upload-csv', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}; 